import React, { ComponentProps } from 'react';
import styled from 'styled-components';
import { mobileMediaQuery, themeColor } from '../../Theming';

interface FormInputType extends ComponentProps<typeof Input> {
  placeholder: string;
  label: string;
  altStyle?: boolean;
}

const Container = styled.div`
  display: block;
  font-size: 1rem;
  font-weight: 400;

  ${mobileMediaQuery} {
    width: 100%;
  }
`;

const Input = styled.input<{ alternate?: boolean }>`
  height: 69px;
  margin-top: 10px;
  width: 371px;
  padding-left: 10px;
  display: block;
  border-radius: 5px;
  border-radius: ${({ alternate }) => (alternate ? '0px' : '5px')};
  border: 1px solid
    ${({ alternate }) =>
      alternate ? themeColor('darkestGrey') : themeColor('darkGrey')};
  -webkit-appearance: none;

  &:hover {
    -webkit-appearance: none;
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ${mobileMediaQuery} {
    border-radius: ${({ alternate }) => alternate && '5px'};
    padding: 0 12px;
    height: 46px;
    width: 100%;
  }
`;

const Label = styled.label<{ alt?: boolean }>`
  color: ${({ alt }) =>
    alt ? themeColor('darkestGrey') : themeColor('darkGrey')};
  font-size: 1rem;
`;

const FormInput: React.FC<FormInputType> = ({
  placeholder,
  label,
  altStyle,
  ...props
}) => {
  return (
    <Container>
      <Label alt={altStyle}>{label}</Label>
      <Input alternate={altStyle} placeholder={placeholder} {...props} />
    </Container>
  );
};

export default FormInput;
